/**
 * Photo URL Utility
 *
 * Centralized function to construct photo URLs for residents
 */

export const getResidentPhotoUrl = (resident) => {


  if (resident?.photo_url) {
    return resident.photo_url;
  }

  if (resident?.profile_photo) {
    // If it's already a full URL, return as is
    if (resident.profile_photo.startsWith('http')) {
      return resident.profile_photo;
    }

    // Otherwise, construct the storage URL
    const baseUrl = import.meta.env.VITE_API_URL?.replace('/api/v1', '') || 'http://localhost:8000';
    const fullUrl = `${baseUrl}/storage/${resident.profile_photo}`;
    return fullUrl;
  }

  return null;
};

export const getResidentInitials = (resident) => {
  if (!resident) return 'N/A';
  const first = resident.first_name?.charAt(0) || '';
  const last = resident.last_name?.charAt(0) || '';
  return (first + last).toUpperCase() || 'N/A';
};

// Test function to check photo URL construction
export const testPhotoUrl = (profilePhoto) => {
  if (!profilePhoto) return null;

  const baseUrl = import.meta.env.VITE_API_URL?.replace('/api/v1', '') || 'http://localhost:8000';
  const fullUrl = `${baseUrl}/storage/${profilePhoto}`;

  return fullUrl;
};

// Proxy URL utility for CORS issues
export const getResidentPhotoProxyUrl = (resident) => {
  if (!resident?.profile_photo) return null;

  // If it's already a full URL, try to convert it to proxy
  if (resident.profile_photo.startsWith('http')) {
    return resident.profile_photo;
  }

  // Use the image proxy endpoint
  const baseUrl = import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1';
  const proxyUrl = `${baseUrl}/image-proxy/${resident.profile_photo}`;
  return proxyUrl;
};

// Enhanced photo URL with fallback to proxy
export const getResidentPhotoUrlWithFallback = (resident) => {
  if (!resident?.profile_photo) return null;

  // For development, prefer direct storage URL first, with proxy as fallback
  const directUrl = getResidentPhotoUrl(resident);
  const proxyUrl = getResidentPhotoProxyUrl(resident);

  return {
    direct: directUrl,
    proxy: proxyUrl
  };
};
